import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getSessions, getHealingRequests, createHealingRequest, getNotifications, markNotificationsRead } from '../utils/api';
import { useWindowSize } from '../utils/useWindowSize';
 
const GeneralDashboard = () => {
  const { user, logout } = useAuth();
  const { isMobile } = useWindowSize();
  const [sessions, setSessions] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('home');
  const [showForm, setShowForm] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifPanel, setShowNotifPanel] = useState(false);
  const [form, setForm] = useState({
    condition: '', description: '', urgency: 'normal',
    isForSelf: true, beneficiaryName: '', beneficiaryAge: '',
    beneficiaryRelationship: 'spouse', beneficiaryRelationshipOther: '',
    medicalReportsShared: false, medicalReportsNote: '',
    consentComplementary: false, consentLiability: false, consentTestimonial: false
  });
 
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(function() {
    var fetchNotifs = async function() {
      try {
        var res = await getNotifications();
        setNotifications(res.data.notifications || []);
        setUnreadCount(res.data.unreadCount || 0);
      } catch (err) {}
    };
    fetchNotifs();
    var interval = setInterval(fetchNotifs, 60000);
    return function() { clearInterval(interval); };
  }, []);

  const fetchData = async () => {
    try {
      var [sessRes, reqRes] = await Promise.all([getSessions(), getHealingRequests()]);
      setSessions(sessRes.data.sessions);
      setRequests(reqRes.data.requests);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.consentComplementary || !form.consentLiability || !form.consentTestimonial) {
      alert('Please agree to all three consent statements before submitting.');
      return;
    }
    try {
      await createHealingRequest({ ...form, isForSelf: form.isForSelf === true || form.isForSelf === 'true' });
      alert('Healing request submitted. Admin will assign a healer shortly.');
      setShowForm(false);
      setForm({
        condition: '', description: '', urgency: 'normal',
        isForSelf: true, beneficiaryName: '', beneficiaryAge: '',
        beneficiaryRelationship: 'spouse', beneficiaryRelationshipOther: '',
        medicalReportsShared: false, medicalReportsNote: '',
        consentComplementary: false, consentLiability: false, consentTestimonial: false
      });
      fetchData();
    } catch (error) {
      alert(error.response ? error.response.data.message : 'Error submitting request');
    }
  };

  const upcomingSessions = sessions.filter(function(s) { return s.status === 'upcoming'; });
  var whatsappReportUrl = 'https://wa.me/919176880807?text=Hello%2C%20I%20would%20like%20to%20share%20my%20medical%20reports%20for%20my%20healing%20request.%20My%20name%20is%20' + encodeURIComponent((user && user.firstName) || '') + '.';

  var statusColors = {
    pending: { bg: '#fef9e7', color: '#d4ac0d' },
    assigned: { bg: '#eaf4fb', color: '#2980b9' },
    in_progress: { bg: '#eafaf1', color: '#27ae60' },
    completed: { bg: '#f0f0f0', color: '#666' }
  };

  var urgencyColors = {
    normal: { bg: '#eafaf1', color: '#27ae60' },
    urgent: { bg: '#fef9e7', color: '#d4ac0d' },
    critical: { bg: '#fdf0f0', color: '#e74c3c' }
  };
 
  const links = [
    { title: 'Book a Healing Session', desc: 'Schedule a one-on-one Pranic Healing session with our certified healers.', url: 'https://pranicwellnesscentre.com/pranic-healing-meditation-and-healing/', color: '#4a8f82' },
    { title: 'Twin Hearts Meditation', desc: 'Join our regular group Twin Hearts Meditation sessions in Chennai.', url: 'https://pranicwellnesscentre.com/twin-hearts-meditation-chennai/', color: '#5a9a6e' },
    { title: 'Upcoming Events', desc: 'View all upcoming workshops, courses and special programmes.', url: 'https://pranicwellnesscentre.com/chennai-pranic-healing-programs/', color: '#00AEEF' },
    { title: 'Healing Courses', desc: 'Explore certified Pranic Healing courses - Basic, Advanced and more.', url: 'https://pranicwellnesscentre.com/pranic-healing-courses-chennai/', color: '#8DC63F' },
    { title: 'Spiritual Courses', desc: 'Discover Arhatic Yoga, Achieving Oneness and other spiritual programmes.', url: 'https://pranicwellnesscentre.com/spiritual-courses-chennai/', color: '#c9a84c' },
    { title: 'About Our Centre', desc: 'Learn about Pranic Wellness Centre, Perungudi, Chennai.', url: 'https://pranicwellnesscentre.com/pranic-healing-center-perungudi/', color: '#4a8f82' },
    { title: 'Contact Us', desc: 'Get in touch with us for any queries or appointments.', url: 'https://pranicwellnesscentre.com/chennai-pranic-healing-Contact/', color: '#5a9a6e' },
    { title: 'WhatsApp Us', desc: 'Chat with us directly on WhatsApp - +91 91768 80807', url: 'https://wa.me/919176880807', color: '#25D366' },
    { title: 'World Pranic Healing', desc: 'Official global resource for Pranic Healing - worldpranichealing.com', url: 'https://www.worldpranichealing.com', color: '#00AEEF' }
  ];
 
  var s = { ...styles,
    ...(isMobile ? {
      topbarInner: { ...styles.topbarInner, padding: '12px 16px', height: 'auto', flexWrap: 'wrap', gap: '8px' },
      container: { ...styles.container, padding: '0 16px' },
      tabs: { ...styles.tabs, overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' },
      welcomeBanner: { ...styles.welcomeBanner, flexDirection: 'column', padding: '20px 16px' },
      upgradeGrid: { ...styles.upgradeGrid, gridTemplateColumns: '1fr' },
      linksGrid: { ...styles.linksGrid, gridTemplateColumns: '1fr' },
      contactStrip: { ...styles.contactStrip, flexDirection: 'column', gap: '16px' },
      contactDivider: { ...styles.contactDivider, display: 'none' },
      sessionItem: { ...styles.sessionItem, gridTemplateColumns: '1fr', gap: '8px' }
    } : {})
  };

  const renderLinkCard = function(link) {
    return (
      <div key={link.url} style={s.linkCard}>
        <div style={{ ...s.linkAccent, background: link.color }}></div>
        <div style={s.linkBody}>
          <div style={s.linkTitle}>{link.title}</div>
          <div style={s.linkDesc}>{link.desc}</div>
          <a href={link.url} target="_blank" rel="noreferrer" style={{ ...s.linkArrow, color: link.color }}>
            Visit
          </a>
        </div>
      </div>
    );
  };
 
  return (
    <div style={s.layout}>
 
      <div style={s.topbar}>
        <div style={s.topbarInner}>
          <img src="https://pranicwellnesscentre.com/wp-content/uploads/2018/10/PH-Revised-Logo.png" alt="Pranic Wellness Centre" style={s.logo} />
          <div style={s.topbarRight}>
            <div style={s.userInfo}>
              <span style={s.userName}>Welcome, {user && user.firstName}</span>
              <span style={s.userRole}>Member</span>
            </div>
            <div style={{ position: 'relative' }}>
              <button onClick={function() {
                setShowNotifPanel(!showNotifPanel);
                if (!showNotifPanel && unreadCount > 0) {
                  markNotificationsRead().then(function() { setUnreadCount(0); setNotifications(function(prev) { return prev.map(function(n) { return Object.assign({}, n, { read: true }); }); }); }).catch(function() {});
                }
              }} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'relative', padding: '4px', color: 'rgba(255,255,255,0.6)', fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: '18px' }}>🔔</span>
                {unreadCount > 0 && (
                  <span style={{ position: 'absolute', top: '-2px', right: '-4px', background: '#e74c3c', color: '#fff', borderRadius: '10px', padding: '1px 5px', fontSize: '9px', fontWeight: '700', minWidth: '14px', textAlign: 'center', lineHeight: '14px' }}>{unreadCount}</span>
                )}
              </button>
              {showNotifPanel && (
                <div style={{ position: 'absolute', top: '40px', right: 0, width: '300px', maxHeight: '360px', overflowY: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 1000, border: '1px solid #e0e0e0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', borderBottom: '1px solid #e0e0e0' }}>
                    <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#666' }}>Notifications</span>
                    <button onClick={function() { setShowNotifPanel(false); }} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '16px' }}>✕</button>
                  </div>
                  <div>
                    {notifications.length === 0 ? (
                      <div style={{ padding: '20px', textAlign: 'center', color: '#999', fontSize: '12px' }}>No notifications</div>
                    ) : notifications.slice(0, 20).map(function(n, i) {
                      return (
                        <div key={i} style={{ padding: '10px 14px', borderBottom: '1px solid #f0f0f0', background: n.read ? '#fff' : '#f9faf7' }}>
                          <div style={{ fontSize: '12px', color: '#333', lineHeight: '1.5' }}>{n.message}</div>
                          <div style={{ fontSize: '10px', color: '#999', marginTop: '3px' }}>{new Date(n.createdAt).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <button onClick={logout} style={s.logoutBtn}>Logout</button>
          </div>
        </div>
      </div>
 
      <div style={s.main}>
        <div style={s.container}>
 
          <div style={s.tabs}>
            {[
              { key: 'home', label: 'Dashboard' },
              { key: 'healing', label: 'Request Healing' },
              { key: 'history', label: 'Healing History (' + requests.length + ')' },
              { key: 'sessions', label: 'Open Sessions (' + upcomingSessions.length + ')' },
              { key: 'links', label: 'Quick Links' }
            ].map(function(tab) {
              return (
                <button key={tab.key} onClick={function() { setActiveTab(tab.key); }}
                  style={activeTab === tab.key ? { ...s.tab, ...s.tabActive } : s.tab}>
                  {tab.label}
                </button>
              );
            })}
          </div>
 
          {loading ? (
            <div style={s.loading}>Loading your dashboard...</div>
          ) : (
            <div>
 
              {activeTab === 'home' && (
                <div>
                  <div style={s.welcomeBanner}>
                    <div style={s.welcomeLeft}>
                      <div style={s.welcomeGreeting}>Hello, {user && user.firstName}!</div>
                      <div style={s.welcomeText}>
                        Welcome to Pranic Wellness Centre. Explore our healing services, upcoming events and meditation sessions below.
                      </div>
                      <div style={s.welcomeActions}>
                        <a href="https://pranicwellnesscentre.com/pranic-healing-courses-chennai/" target="_blank" rel="noreferrer" style={s.welcomeBtn}>
                          View Courses
                        </a>
                        <button onClick={function() { setActiveTab('healing'); setShowForm(true); }} style={{ ...s.welcomeBtn, background: '#25D366', border: 'none', cursor: 'pointer' }}>
                          Request Healing
                        </button>
                      </div>
                    </div>
                    <div style={s.welcomeRight}>
                      <div style={s.welcomeStatNum}>{upcomingSessions.length}</div>
                      <div style={s.welcomeStatLabel}>Open Sessions Available</div>
                      <button onClick={function() { setActiveTab('sessions'); }} style={s.viewSessionsBtn}>
                        View Sessions
                      </button>
                    </div>
                  </div>
 
                  <div style={s.upgradeGrid}>
                    <div style={s.upgradeCard}>
                      <div style={{ ...s.upgradeIconCircle, background: '#eafaf1' }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#27ae60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div>
                        <div style={s.upgradeCardTitle}>Become a Student Member</div>
                        <div style={s.upgradeCardText}>Have you completed a Pranic Healing course? Register as a Student to access course materials and eligible training sessions.</div>
                        <a href="https://pranicwellnesscentre.com/pranic-healing-courses-chennai/" target="_blank" rel="noreferrer" style={s.upgradeCardLink}>Explore Courses</a>
                      </div>
                    </div>
                    <div style={s.upgradeCard}>
                      <div style={{ ...s.upgradeIconCircle, background: '#eaf4fb' }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="#2980b9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div>
                        <div style={s.upgradeCardTitle}>Become a Patient Member</div>
                        <div style={s.upgradeCardText}>Looking for Pranic Healing treatment? Register as a Patient to submit healing requests and get assigned to a certified healer.</div>
                        <button onClick={function() { setActiveTab('healing'); setShowForm(true); }} style={{ ...s.upgradeCardLink, color: '#2980b9', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>Request Healing</button>
                      </div>
                    </div>
                  </div>
 
                  <div style={s.sectionTitle}>Quick Access</div>
                  <div style={s.linksGrid}>
                    {links.slice(0, 6).map(renderLinkCard)}
                  </div>
 
                  <div style={s.contactStrip}>
                    <div style={s.contactItem}>
                      <div style={s.contactLabel}>Phone</div>
                      <div style={s.contactValue}>+91 91768 80807</div>
                    </div>
                    <div style={s.contactDivider}></div>
                    <div style={s.contactItem}>
                      <div style={s.contactLabel}>Email</div>
                      <div style={s.contactValue}>pranicwellnesscentre@gmail.com</div>
                    </div>
                    <div style={s.contactDivider}></div>
                    <div style={s.contactItem}>
                      <div style={s.contactLabel}>Address</div>
                      <div style={s.contactValue}>Kurinji Nagar, Perungudi, Chennai 600096</div>
                    </div>
                    <div style={s.contactDivider}></div>
                    <div style={s.contactItem}>
                      <div style={s.contactLabel}>Hours</div>
                      <div style={s.contactValue}>Monday to Sunday: 9 AM to 6 PM</div>
                    </div>
                  </div>
                </div>
              )}
 
              {activeTab === 'healing' && (
                <div style={s.card}>
                  <div style={{ padding: '20px 28px', borderBottom: '1px solid #e0e0e0', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? '12px' : '0' }}>
                    <div>
                      <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e' }}>Request Healing</div>
                      <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>Submit a healing request for yourself or someone else</div>
                    </div>
                    <button onClick={function() { setShowForm(!showForm); }} style={{ background: '#4a8f82', color: '#fff', border: 'none', borderRadius: '4px', padding: '9px 18px', fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer' }}>
                      {showForm ? 'Cancel' : '+ New Request'}
                    </button>
                  </div>
                  {showForm && (
                    <div style={{ padding: '24px', borderBottom: '1px solid #e0e0e0', background: '#f9faf7' }}>
                      <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '20px' }}>New Healing Request</div>
                      <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '20px' }}>
                          <div style={s.formLabel}>Who is this request for?</div>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button type="button" onClick={function() { setForm({ ...form, isForSelf: true }); }}
                              style={form.isForSelf ? s.toggleBtnActive : s.toggleBtn}>Myself</button>
                            <button type="button" onClick={function() { setForm({ ...form, isForSelf: false }); }}
                              style={!form.isForSelf ? s.toggleBtnActive : s.toggleBtn}>Someone Else</button>
                          </div>
                        </div>

                        {!form.isForSelf && (
                          <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '16px', marginBottom: '20px' }}>
                            <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', color: '#4a8f82', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '14px' }}>Beneficiary Details</div>
                            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '16px' }}>
                              <div>
                                <label style={s.formLabel}>Patient Name</label>
                                <input style={s.formInput} value={form.beneficiaryName} onChange={function(e) { setForm({ ...form, beneficiaryName: e.target.value }); }} placeholder="Full name" required={!form.isForSelf} />
                              </div>
                              <div>
                                <label style={s.formLabel}>Age</label>
                                <input style={s.formInput} type="number" value={form.beneficiaryAge} onChange={function(e) { setForm({ ...form, beneficiaryAge: e.target.value }); }} placeholder="Age" min="1" max="120" required={!form.isForSelf} />
                              </div>
                              <div>
                                <label style={s.formLabel}>Relationship</label>
                                <select style={s.formInput} value={form.beneficiaryRelationship} onChange={function(e) { setForm({ ...form, beneficiaryRelationship: e.target.value }); }}>
                                  <option value="spouse">Spouse</option>
                                  <option value="child">Child</option>
                                  <option value="parent">Parent</option>
                                  <option value="sibling">Sibling</option>
                                  <option value="friend">Friend</option>
                                  <option value="other">Other</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}

                        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                          <div>
                            <label style={s.formLabel}>Condition / Health Concern</label>
                            <input style={s.formInput} value={form.condition} onChange={function(e) { setForm({ ...form, condition: e.target.value }); }} placeholder="e.g. Diabetes, Back Pain" required />
                          </div>
                          <div>
                            <label style={s.formLabel}>Urgency</label>
                            <select style={s.formInput} value={form.urgency} onChange={function(e) { setForm({ ...form, urgency: e.target.value }); }}>
                              <option value="normal">Normal</option>
                              <option value="urgent">Urgent</option>
                              <option value="critical">Critical</option>
                            </select>
                          </div>
                          <div style={{ gridColumn: '1 / -1' }}>
                            <label style={s.formLabel}>Detailed Description</label>
                            <textarea style={{ ...s.formInput, height: '100px', resize: 'vertical' }} value={form.description} onChange={function(e) { setForm({ ...form, description: e.target.value }); }} placeholder="Describe symptoms, duration, previous treatments..." required />
                          </div>
                        </div>

                        <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '16px', marginBottom: '20px' }}>
                          <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px', gap: isMobile ? '12px' : '0' }}>
                            <div>
                              <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '13px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' }}>Medical Reports</div>
                              <div style={{ fontSize: '12px', color: '#666' }}>Share medical reports via WhatsApp to help our healers.</div>
                            </div>
                            <a href={whatsappReportUrl} target="_blank" rel="noreferrer" style={{ display: 'inline-block', background: '#25D366', color: '#fff', padding: '9px 18px', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none', flexShrink: 0 }}>Share via WhatsApp</a>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input type="checkbox" checked={form.medicalReportsShared} onChange={function(e) { setForm({ ...form, medicalReportsShared: e.target.checked }); }} style={{ marginRight: '8px', accentColor: '#4a8f82' }} />
                            <span style={{ fontSize: '13px', color: '#333' }}>I have shared / will share my medical reports via WhatsApp</span>
                          </div>
                        </div>

                        <div style={{ background: '#fff', border: '2px solid #4a8f82', borderRadius: '8px', padding: '20px 24px', marginBottom: '20px' }}>
                          <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '14px', fontWeight: '700', color: '#1a1a2e', marginBottom: '6px' }}>Consent Declaration</div>
                          <div style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>Please agree to all three statements before submitting.</div>
                          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '14px', paddingBottom: '14px', borderBottom: '1px solid #f0f0f0' }}>
                            <input type="checkbox" checked={form.consentComplementary} onChange={function(e) { setForm({ ...form, consentComplementary: e.target.checked }); }} style={{ marginRight: '12px', accentColor: '#4a8f82', flexShrink: 0, marginTop: '2px' }} />
                            <span style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>I understand that Pranic Healing is not meant to replace conventional medicine but rather to complement it.</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '14px', paddingBottom: '14px', borderBottom: '1px solid #f0f0f0' }}>
                            <input type="checkbox" checked={form.consentLiability} onChange={function(e) { setForm({ ...form, consentLiability: e.target.checked }); }} style={{ marginRight: '12px', accentColor: '#4a8f82', flexShrink: 0, marginTop: '2px' }} />
                            <span style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>I hereby release the person or organisations providing Pranic Healing from any liabilities as a result of the service received by me.</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <input type="checkbox" checked={form.consentTestimonial} onChange={function(e) { setForm({ ...form, consentTestimonial: e.target.checked }); }} style={{ marginRight: '12px', accentColor: '#4a8f82', flexShrink: 0, marginTop: '2px' }} />
                            <span style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>I hereby give my consent to the healer to use this testimonial for his Pranic Healing Certification Program.</span>
                          </div>
                        </div>

                        <div style={{ display: 'flex', gap: '12px' }}>
                          <button type="submit" style={{ background: '#4a8f82', color: '#fff', border: 'none', borderRadius: '4px', padding: '12px 28px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer' }}>Submit Healing Request</button>
                          <button type="button" onClick={function() { setShowForm(false); }} style={{ background: 'transparent', color: '#666', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '12px 24px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Cancel</button>
                        </div>
                      </form>
                    </div>
                  )}
                  <div style={{ padding: '8px 0' }}>
                    {requests.length === 0 ? (
                      <div style={{ padding: '48px', textAlign: 'center' }}>
                        <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px' }}>No healing requests yet</div>
                        <div style={{ fontSize: '13px', color: '#999', marginBottom: '16px' }}>Click "+ New Request" to submit your first healing request.</div>
                      </div>
                    ) : requests.map(function(req) {
                      return (
                        <div key={req._id} style={{ padding: '16px 24px', borderBottom: '1px solid #f5f5f5' }}>
                          <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px', gap: isMobile ? '8px' : '0' }}>
                            <div>
                              <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '14px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' }}>
                                {req.condition}
                                {!req.isForSelf && req.beneficiaryName && <span style={{ marginLeft: '8px', fontSize: '11px', color: '#4a8f82', fontStyle: 'italic' }}>for {req.beneficiaryName}</span>}
                              </div>
                              <div style={{ fontSize: '12px', color: '#666' }}>{req.description && req.description.substring(0, 120)}...</div>
                              <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>Requested: {new Date(req.requestedAt).toLocaleDateString('en-IN')} | Sessions: {req.totalSessionsCompleted} | Healer: {req.assignedHealer ? req.assignedHealer.firstName + ' ' + req.assignedHealer.lastName : 'Pending'}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '6px' }}>
                              <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', padding: '4px 10px', borderRadius: '20px', background: urgencyColors[req.urgency] ? urgencyColors[req.urgency].bg : '#f0f0f0', color: urgencyColors[req.urgency] ? urgencyColors[req.urgency].color : '#666' }}>{req.urgency}</span>
                              <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', padding: '4px 10px', borderRadius: '20px', background: statusColors[req.status] ? statusColors[req.status].bg : '#f0f0f0', color: statusColors[req.status] ? statusColors[req.status].color : '#666' }}>{req.status ? req.status.replace('_', ' ') : ''}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeTab === 'history' && (
                <div style={s.card}>
                  <div style={{ padding: '20px 28px', borderBottom: '1px solid #e0e0e0' }}>
                    <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e' }}>Healing History</div>
                    <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>Complete record of all your healing sessions</div>
                  </div>
                  <div style={{ padding: '8px 0' }}>
                    {requests.length === 0 ? (
                      <div style={{ padding: '48px', textAlign: 'center' }}>
                        <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px' }}>No healing history yet</div>
                        <div style={{ fontSize: '13px', color: '#999' }}>Your session history will appear here after your first session.</div>
                      </div>
                    ) : requests.map(function(req) {
                      if (!req.sessions || req.sessions.length === 0) return null;
                      return (
                        <div key={req._id} style={{ borderBottom: '2px solid #f0f0f0' }}>
                          <div style={{ padding: '16px 24px 8px', background: '#f9faf7' }}>
                            <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '15px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' }}>
                              {req.condition}
                              {!req.isForSelf && req.beneficiaryName && <span style={{ marginLeft: '8px', fontSize: '11px', color: '#4a8f82', fontStyle: 'italic' }}>for {req.beneficiaryName}</span>}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>{req.sessions.length} sessions | Healer: {req.assignedHealer ? req.assignedHealer.firstName + ' ' + req.assignedHealer.lastName : 'Unassigned'}</div>
                          </div>
                          {req.sessions.map(function(session, index) {
                            return (
                              <div key={index} style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '160px 1fr auto', gap: isMobile ? '8px' : '16px', alignItems: 'start', padding: isMobile ? '14px 16px' : '14px 24px', borderBottom: '1px solid #f5f5f5' }}>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#4a8f82', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>#{index + 1}</div>
                                  <div>
                                    <div style={{ fontFamily: "'Raleway', sans-serif", fontSize: '13px', fontWeight: '700', color: '#1a1a2e', marginBottom: '2px' }}>{new Date(session.date).toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}</div>
                                    <div style={{ fontSize: '11px', color: '#999' }}>{session.duration} mins</div>
                                  </div>
                                </div>
                                <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6' }}>{session.session_notes_patient || session.healerRemarks || 'No remarks'}</div>
                                <span style={{ fontFamily: "'Raleway', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', padding: '4px 10px', borderRadius: '20px', background: session.status === 'completed' ? '#eafaf1' : '#fef9e7', color: session.status === 'completed' ? '#27ae60' : '#d4ac0d' }}>{session.status}</span>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeTab === 'sessions' && (
                <div style={s.card}>
                  <div style={s.cardHeader}>
                    <div>
                      <div style={s.cardTitle}>Open Sessions and Events</div>
                      <div style={s.cardSub}>Sessions open to all members — register via WhatsApp</div>
                    </div>
                  </div>
                  <div style={s.cardBody}>
                    {upcomingSessions.length === 0 ? (
                      <div style={s.empty}>
                        <div style={s.emptyTitle}>No open sessions at the moment</div>
                        <div style={s.emptySub}>Check back soon or visit our events page for upcoming programmes.</div>
                        <a href="https://pranicwellnesscentre.com/chennai-pranic-healing-programs/" target="_blank" rel="noreferrer" style={s.emptyLink}>
                          View Events Page
                        </a>
                      </div>
                    ) : upcomingSessions.map(function(session) {
                      return (
                        <div key={session._id} style={s.sessionItem}>
                          <div style={s.sessionDateBox}>
                            <span style={s.sessionDay}>{new Date(session.date).getDate()}</span>
                            <span style={s.sessionMonth}>{new Date(session.date).toLocaleString('en-IN', { month: 'short' })}</span>
                          </div>
                          <div style={s.sessionContent}>
                            <div style={s.sessionTitle}>{session.title}</div>
                            <div style={s.sessionMeta}>{session.startTime} to {session.endTime} | {session.venue}</div>
                            <div style={s.sessionMeta}>{session.currentEnrollments}/{session.maxParticipants} enrolled | {session.type ? session.type.replace(/_/g, ' ') : ''}</div>
                          </div>
                          <a href="https://wa.me/919176880807?text=Hello%2C%20I%20would%20like%20to%20register%20for%20the%20session." target="_blank" rel="noreferrer" style={s.sessionRegBtn}>
                            Register
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
 
              {activeTab === 'links' && (
                <div>
                  <div style={s.sectionTitle}>All Quick Links</div>
                  <div style={s.linksGrid}>
                    {links.map(renderLinkCard)}
                  </div>
                </div>
              )}
 
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
 
const styles = {
  layout: { minHeight: '100vh', background: '#f5f8f5', fontFamily: "'Open Sans', sans-serif" },
  topbar: { background: 'linear-gradient(135deg, #071e12, #0c2617)', borderBottom: '3px solid #4a8f82' },
  topbarInner: { maxWidth: '1100px', margin: '0 auto', padding: '0 32px', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  logo: { height: '40px' },
  topbarRight: { display: 'flex', alignItems: 'center', gap: '20px' },
  userInfo: { textAlign: 'right' },
  userName: { display: 'block', fontFamily: "'Raleway', sans-serif", fontSize: '14px', fontWeight: '700', color: '#fff' },
  userRole: { fontSize: '10px', color: '#8DC63F', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: '700' },
  logoutBtn: { padding: '8px 20px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.7)', cursor: 'pointer' },
  main: { padding: '32px 0' },
  container: { maxWidth: '1100px', margin: '0 auto', padding: '0 32px' },
  tabs: { display: 'flex', gap: '4px', background: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '6px', marginBottom: '24px', width: 'fit-content' },
  tab: { padding: '10px 24px', background: 'transparent', border: 'none', borderRadius: '6px', fontFamily: "'Raleway', sans-serif", fontSize: '13px', fontWeight: '700', color: '#666', cursor: 'pointer' },
  tabActive: { background: '#4a8f82', color: '#fff' },
  loading: { textAlign: 'center', padding: '60px', color: '#666', fontSize: '14px' },
  welcomeBanner: { background: 'linear-gradient(135deg, #071e12, #0c2617)', borderRadius: '8px', padding: '32px', marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '32px' },
  welcomeLeft: { flex: 1 },
  welcomeGreeting: { fontFamily: "'Raleway', sans-serif", fontSize: '22px', fontWeight: '700', color: '#fff', marginBottom: '8px' },
  welcomeText: { fontSize: '13px', color: 'rgba(255,255,255,0.55)', lineHeight: '1.7', maxWidth: '500px', marginBottom: '20px' },
  welcomeActions: { display: 'flex', gap: '12px' },
  welcomeBtn: { display: 'inline-block', background: '#4a8f82', color: '#fff', padding: '10px 24px', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none', whiteSpace: 'nowrap' },
  welcomeRight: { flexShrink: 0, background: 'rgba(255,255,255,0.06)', borderRadius: '8px', padding: '24px 32px', textAlign: 'center' },
  welcomeStatNum: { fontFamily: "'Raleway', sans-serif", fontSize: '48px', fontWeight: '700', color: '#8DC63F', lineHeight: 1, marginBottom: '8px' },
  welcomeStatLabel: { fontSize: '12px', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px' },
  viewSessionsBtn: { background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.7)', borderRadius: '4px', padding: '8px 20px', fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '1px' },
  upgradeGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '32px' },
  upgradeCard: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '24px', display: 'flex', gap: '16px', alignItems: 'flex-start' },
  upgradeIconCircle: { width: '48px', height: '48px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  upgradeCardTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '15px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px' },
  upgradeCardText: { fontSize: '13px', color: '#666', lineHeight: '1.7', marginBottom: '12px' },
  upgradeCardLink: { fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', color: '#4a8f82', textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '1px' },
  sectionTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '18px', fontWeight: '700', color: '#1a1a2e', marginBottom: '20px' },
  linksGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '32px' },
  linkCard: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' },
  linkAccent: { height: '3px', width: '100%' },
  linkBody: { padding: '20px 22px' },
  linkTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '15px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px' },
  linkDesc: { fontSize: '13px', color: '#666', lineHeight: '1.6', marginBottom: '12px' },
  linkArrow: { fontSize: '12px', fontWeight: '700', fontFamily: "'Raleway', sans-serif", textDecoration: 'none' },
  contactStrip: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '24px 32px', display: 'flex', alignItems: 'center' },
  contactItem: { flex: 1, textAlign: 'center' },
  contactLabel: { fontFamily: "'Raleway', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#999', marginBottom: '4px' },
  contactValue: { fontSize: '13px', color: '#333', fontWeight: '600' },
  contactDivider: { width: '1px', height: '40px', background: '#e0e0e0', flexShrink: 0 },
  card: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' },
  cardHeader: { padding: '20px 28px', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  cardTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e' },
  cardSub: { fontSize: '12px', color: '#999', marginTop: '2px' },
  cardBody: { padding: '8px 0' },
  empty: { padding: '48px', textAlign: 'center' },
  emptyTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px' },
  emptySub: { fontSize: '13px', color: '#999', marginBottom: '20px' },
  emptyLink: { display: 'inline-block', background: '#4a8f82', color: '#fff', padding: '10px 24px', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none' },
  sessionItem: { display: 'grid', gridTemplateColumns: '64px 1fr auto', gap: '16px', alignItems: 'center', padding: '16px 28px', borderBottom: '1px solid #f5f5f5' },
  sessionDateBox: { background: 'linear-gradient(135deg, #071e12, #0c2617)', borderRadius: '8px', padding: '10px', textAlign: 'center' },
  sessionDay: { display: 'block', fontFamily: "'Raleway', sans-serif", fontSize: '22px', fontWeight: '700', color: '#8DC63F', lineHeight: 1 },
  sessionMonth: { fontSize: '10px', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '1px' },
  sessionContent: {},
  sessionTitle: { fontFamily: "'Raleway', sans-serif", fontSize: '15px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' },
  sessionMeta: { fontSize: '12px', color: '#666' },
  sessionRegBtn: { display: 'inline-block', background: '#4a8f82', color: '#fff', padding: '9px 20px', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', textDecoration: 'none', whiteSpace: 'nowrap' },
  formLabel: { display: 'block', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: '#666', marginBottom: '6px', fontFamily: "'Raleway', sans-serif" },
  formInput: { width: '100%', padding: '10px 14px', border: '1px solid #e0e0e0', borderRadius: '5px', fontSize: '14px', fontFamily: "'Open Sans', sans-serif", boxSizing: 'border-box', color: '#333' },
  toggleBtn: { padding: '9px 24px', background: '#fff', border: '1px solid #e0e0e0', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', color: '#666', cursor: 'pointer' },
  toggleBtnActive: { padding: '9px 24px', background: '#4a8f82', border: '1px solid #4a8f82', borderRadius: '4px', fontFamily: "'Raleway', sans-serif", fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer' }
};
 
export default GeneralDashboard;